import { format } from "date-fns"
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks"
import { colors } from "../../ui/color"
import { SearchIcon } from "../../ui/icons/searchIcon"
import Button from "../../ui/molecoles/button"
import { Calendar } from "../../ui/molecoles/calendar"
import { InputComponent } from "../../ui/molecoles/input"
import { SelectComponent } from "../../ui/molecoles/select"
import { findAllReport, setFilterArrivalAirport, setFilterDepartureAirport, setFilterFlightIdent, setFilterReportFromDate, setFilterSort, setFilterSortBy, setReportFilterPage } from "./slice"

export function ReportFilter() {
    const dispatch = useAppDispatch()
    const reportState = useAppSelector(state => state.report)

    return (
        <div className={"flex flex-row gap-4 w-full"}>
            <div className={"flex flex-row gap-4 w-full"}>
                <InputComponent
                    placeholder="Search flight id"
                    startIcon={<SearchIcon size={20} color={colors.neutral[400]} />}
                    type={"text"}
                    onChangeText={(value) => dispatch(setFilterFlightIdent(value))}
                    value={reportState.findAllFilters.flightIdent}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            dispatch(findAllReport({ ...reportState.findAllFilters, page: 1 }))
                        }
                    }}
                />
                <SelectComponent
                    placeholder="Departure airport"
                    onChange={(value) => {
                        dispatch(findAllReport({
                            page: 1,
                            pageSize: reportState.findAllFilters.pageSize,
                            sort: reportState.findAllFilters.sort,
                            sortBy: reportState.findAllFilters.sortBy,
                            name: reportState.findAllFilters.name,
                            surname: reportState.findAllFilters.surname,
                            flightIdent: reportState.findAllFilters.flightIdent,
                            departureAirport: value!,
                            arrivalAirport: reportState.findAllFilters.arrivalAirport,
                            fromDate: reportState.findAllFilters.fromDate
                        }))
                        dispatch(setFilterDepartureAirport(value))
                    }}
                    options={reportState.distinctAirportsResponse?.departure_airports !== null ? reportState.distinctAirportsResponse?.departure_airports.map((value) => ({ label: (value), value: value }))! : []}
                    value={reportState.findAllFilters.departureAirport}
                    noOptionsMessage="No airport available"
                />
                <SelectComponent
                    placeholder="Arrival airport"
                    onChange={(value) => {
                        dispatch(findAllReport({
                            page: 1,
                            pageSize: reportState.findAllFilters.pageSize,
                            sort: reportState.findAllFilters.sort,
                            sortBy: reportState.findAllFilters.sortBy,
                            name: reportState.findAllFilters.name,
                            surname: reportState.findAllFilters.surname,
                            flightIdent: reportState.findAllFilters.flightIdent,
                            departureAirport: reportState.findAllFilters.departureAirport,
                            fromDate: reportState.findAllFilters.fromDate,
                            arrivalAirport: value!
                        }))
                        dispatch(setFilterArrivalAirport(value))
                    }}
                    options={reportState.distinctAirportsResponse?.arrival_airports !== null ? reportState.distinctAirportsResponse?.arrival_airports.map((value) => ({ label: (value), value: value }))! : []}
                    value={reportState.findAllFilters.arrivalAirport}
                    noOptionsMessage="No airport available"
                />
                <Calendar
                    startDate={
                        reportState.findAllFilters.fromDate !== "" ?
                            new Date(reportState.findAllFilters.fromDate) :
                            null
                    }
                    setStartDate={(date) => {
                        dispatch(findAllReport({
                            page: 1,
                            pageSize: reportState.findAllFilters.pageSize,
                            sort: reportState.findAllFilters.sort,
                            sortBy: reportState.findAllFilters.sortBy,
                            name: reportState.findAllFilters.name,
                            surname: reportState.findAllFilters.surname,
                            flightIdent: reportState.findAllFilters.flightIdent,
                            departureAirport: reportState.findAllFilters.departureAirport,
                            arrivalAirport: reportState.findAllFilters.arrivalAirport,
                            fromDate: format(new Date(date!), "yyyy-MM-dd")
                        }))
                        dispatch(setFilterReportFromDate(format(new Date(date!), "yyyy-MM-dd")))
                    }}
                    type={"date"}
                />
            </div>
            <div className={"gap-2 flex flex-row"}>
                <Button
                    label="Clean"
                    size={"md"}
                    iconPosition={"off"}
                    variant={"outline"}
                    color={"gray"}
                    onClick={() => {
                        dispatch(setFilterFlightIdent(""))
                        dispatch(setFilterSort(-1))
                        dispatch(setFilterSortBy(""))
                        dispatch(setFilterDepartureAirport(""))
                        dispatch(setFilterArrivalAirport(""))
                        dispatch(setFilterReportFromDate(""))
                        dispatch(setReportFilterPage(1))
                        dispatch(findAllReport({
                            page: 1,
                            pageSize: reportState.findAllFilters.pageSize,
                            sort: reportState.findAllFilters.sort,
                            sortBy: "",
                            name: "",
                            surname: "",
                            flightIdent: "",
                            departureAirport: "",
                            arrivalAirport: "",
                            fromDate: ""
                        }))
                    }}
                />
                <Button
                    label="Apply"
                    size={"md"}
                    iconPosition={"off"}
                    variant={"outline"}
                    color={"blue"}
                    onClick={() => {
                        dispatch(findAllReport({
                            page: 1,
                            pageSize: reportState.findAllFilters.pageSize,
                            sort: reportState.findAllFilters.sort,
                            sortBy: reportState.findAllFilters.sortBy,
                            name: reportState.findAllFilters.name,
                            surname: reportState.findAllFilters.surname,
                            flightIdent: reportState.findAllFilters.flightIdent,
                            departureAirport: reportState.findAllFilters.departureAirport,
                            arrivalAirport: reportState.findAllFilters.arrivalAirport,
                            fromDate: reportState.findAllFilters.fromDate
                        }))
                    }}
                />
            </div>
        </div>
    )
}